<template>
    <div class="star-cluster" aria-hidden="true">
        <div style="height: 3px; width: 3px"></div>
        <div style="height: 2px; width: 2px"></div>
        <div style="height: 1px; width: 1px"></div>
    </div>
</template>
